// 采购管理
export default {
  namespaced: true,
  state: () => ({
    // 采购验收：已选订单验收
    procurementAcceptanceSelectedForCheckOrders: [],
    // 采购验收：已选订单收货地址
    collectionPlaceInfo: {},
  }),
  getters: {},
  mutations: {
    setProcurementAcceptanceSelectedForCheckOrders(state, payload = {}) {
      state.procurementAcceptanceSelectedForCheckOrders = payload
      if(payload && payload.length>0) {
        state.collectionPlaceInfo = { 
          collectionPlace:payload[0]?.collectionPlace || "",
          collectionPlaceName :payload[0]?.collectionPlaceName || "",
        }
      } else {
        state.collectionPlaceInfo = {}
      }
    },
  },
  actions: {}
}
